import { createSelector } from '@reduxjs/toolkit';
import { TStoreState } from 'redux/types';
import { EAuthStatus } from 'services/auth';
import { IAuthStore, TSavedUrl } from 'redux/reducers/auth/types';

// ==========================================:
const getAuthState = (state: TStoreState): IAuthStore => state.auth;
export const getAuth = createSelector([getAuthState], (auth: IAuthStore) => auth);

// ====================================================:
export const getIsAuth = createSelector(
	[getAuth],
	(auth: IAuthStore): boolean => auth.isAuthenticated,
);

export const getAuthStatus = createSelector([getAuth], (auth: IAuthStore) => auth.status);

export const getIsAuthPending = createSelector(
	[getAuthStatus],
	(status: EAuthStatus): boolean =>
		status === EAuthStatus.Unknown || status === EAuthStatus.Authenticating,
);

// ====================================================:
export const getAccountLoginLoader = createSelector(
	[getAuth],
	(auth: IAuthStore): boolean => auth.loginLoader,
);

// ====================================================:
export const getMerchantId = createSelector([getAuthState], (auth: IAuthStore) => auth.xMerchantId);

// ====================================================:
export const getSavedUrl = createSelector(
	[getAuthState],
	(auth: IAuthStore): TSavedUrl => auth.savedUrl,
);

export const getSavedUrl2 = createSelector(
	[getAuthState],
	(auth: IAuthStore): TSavedUrl => auth.savedUrl2,
);

export const getSavedUrl3 = createSelector(
	[getAuthState],
	(auth: IAuthStore): TSavedUrl => auth.savedUrl3,
);

// ====================================================:
const EMPTY_REALM_ROLES: string[] = [];

/** Keycloak realm roles of the current access token (e.g. `paymentgateway_admin`). */
export const selectRealmRoles = (state: TStoreState): string[] =>
	state.auth.realmRoles ?? EMPTY_REALM_ROLES;
